//#region src/config.ts
var BitcartApiConfig = class BitcartApiConfig {
	static #baseUrl = "";
	/**
	* @throws When the base URL has not been set yet.
	*/
	static get baseUrl() {
		if (!BitcartApiConfig.#baseUrl) throw new Error("BitcartApiConfig.baseUrl is unset. Call BitcartApiConfig.set() during initialization.");
		return BitcartApiConfig.#baseUrl;
	}
	/**
	* @throws When the base URL has not been set yet.
	*/
	static get websocketBaseUrl() {
		return BitcartApiConfig.baseUrl.replace(/^http/, "ws");
	}
	/**
	* Points the SDK at an API instance.
	*
	* Must be called once in the app's initialization layer.
	*/
	static set({ baseUrl }) {
		BitcartApiConfig.#baseUrl = baseUrl.replace(/\/$/, "");
	}
};
//#endregion
export { BitcartApiConfig };

//# sourceMappingURL=config.js.map